import { getWelcomeMessageForGroup } from '../../lib/funnels/functions/v1/chat/getWelcomeMsgForGroups'
import { getGroupIdFromParams } from '../../lib/funnels/functions/v1/chat/getGroupIdFromParams'
// import { initChatAnalytics } from '../../lib/funnels/functions/v1/chat/initChatAnalytics'
import { initLiveChatSDK } from '../../lib/funnels/functions/v1/chat/initLiveChatSDK'
import { setupChatEventsHandlers } from '../../lib/funnels/functions/v1/chat/setupChatEventsHandlers'
import { saveChatSession } from '../../lib/funnels/functions/v1/chat/saveChatSession'
import { getChatSession } from '../../lib/funnels/functions/v1/chat/getChatSession'
import { sendMessage } from '../../lib/funnels/functions/v1/chat/sendMessage'
import { rateChat } from '../../lib/funnels/functions/v1/chat/rateChat'
import { setChatCompanyFromUrl } from '../../lib/funnels/functions/v1/chat/chatCompanyCookie'
import { submitLopEvent } from '../../lib/funnels/functions/v1/lop/submitLopEvent'
/**
 * TODO: Pending messages, interval for SDK load
 */

let sdkInstance =
  /** @type {import('@livechat/customer-sdk').CustomerSDK | null} */ (null)

document.addEventListener('DOMContentLoaded', async () => {
  // Prevent multiple initializations
  // @ts-ignore
  if (window.__liveChatInitialized) {
    return
  }
  // @ts-ignore
  window.__liveChatInitialized = true

  const paramGroupId = getGroupIdFromParams()
  const groupId = parseInt(paramGroupId, 10)
  const welcomeMessage = getWelcomeMessageForGroup(paramGroupId)

  const session = getChatSession()
  saveChatSession({
    ...session,
    groupId,
    welcomeMessage,
  })

  if (sdkInstance === null) {
    sdkInstance = initLiveChatSDK(groupId)
  }

  if (!sdkInstance) {
    throw new Error('Live chat SDK could not be initialized')
  }

  // get `company` param from encoded URL params & set cookie for thanks page downsell
  setChatCompanyFromUrl()

  // initChatAnalytics() // Analytics if needed (uncomment after chat dev done)

  sdkInstance.connect()

  setupChatEventsHandlers(sdkInstance)

  // LOP events — only fire when flow param is present
  const flow = new URLSearchParams(window.location.search).get('flow')
  let chatStarted = false

  if (flow) {
    submitLopEvent({ flow, event: 'chat_loaded' })
  }

  const sendButton = document.getElementById('send-button')
  const messageInput = /** @type {HTMLTextAreaElement | null} */ (
    document.getElementById('message-input')
  )
  if (!sendButton || !messageInput) {
    return
  }

  /** @param {string} messageText */
  function handleSend(messageText) {
    if (!sdkInstance) {
      throw Error('unexpected: chat sdk not found')
    }
    if (flow && !chatStarted && messageText) {
      chatStarted = true
      submitLopEvent({ flow, event: 'chat_started' })
    }
    sendMessage(sdkInstance, messageText)
  }

  sendButton.addEventListener('click', (e) => {
    e.preventDefault()
    const messageText = messageInput.value.trim()
    handleSend(messageText)
  })

  messageInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      const messageText = messageInput.value.trim()
      handleSend(messageText)
    }
  })

  const ratingButtons = document.querySelectorAll('#rating svg')
  ratingButtons.forEach((b) => {
    b.addEventListener('click', () => {
      if (!sdkInstance) {
        throw Error('unexpected: chat sdk not found')
      }
      const rating = b.id === 'thumbs-up' ? 1 : 0
      rateChat(sdkInstance, rating)
    })
  })
})

// // Start a new chat with LiveChat
// // @ts-ignore
// function startChat(lcState, chatState, _msgId, _msgText) {
//   lcState.activating = true

//   // Small delay to ensure SDK initialization completes
//   setTimeout(() => {
//     // @ts-ignore
//     sdkInstance
//       .startChat({ continuous: true })
//       // @ts-ignore
//       .then(({ chat }) => {
//         lcState.chat = chat.id
//         chatState.updateLivechatData({ chat: chat.id })
//         lcState.active = true
//         lcState.activating = false

//         // Send any pending messages
//         // @ts-ignore
//         // lcState.pendingMessages.forEach(({ messageId, text }) => {
//         //   sendLiveChatMessage(chat.id, messageId, text)
//         // })

//         lcState.pendingMessages = []
//       })
//       // @ts-ignore
//       .catch((error) => {
//         // If SDK destroyed, try to reinitialize
//         if (error.code === 'SDK_DESTROYED') {
//           // Reset SDK to null so it can be reinitialized on next attempt
//           sdkInstance = null
//         }

//         lcState.activating = false

//         // Mark all pending messages as failed
//         lcState.pendingMessages = []

//         // Fallback - still show the message in UI
//         // if (!document.getElementById(msgId)) {
//         //   const messageElement = createMessage(msgId, msgText, 'user')
//         //   appendMessage(messageElement)
//         // }
//       })
//   }, 500)
// }

// // Resume an existing chat with LiveChat
// // @ts-ignore
// export function resumeExistingChat(lcState, chatState, msgId, msgText) {
//   lcState.activating = true

//   // Check if sdkInstance is null and reinitialize if needed
//   // @ts-ignore
//   if (sdkInstance === null) {
//     // @ts-ignore
//     sdkInstance = CustomerSDK.init({
//       organizationId: 'a2805e9c-4b8d-4312-8820-a5eaeb56e6f3',
//       clientId: 'f0b21a3f79f5ab335c4a6661f38401de',
//       // groupId: globalConfig.groupId,
//     })
//   }

//   // Small delay to ensure SDK initialization completes
//   setTimeout(() => {
//     // @ts-ignore
//     sdkInstance
//       .resumeChat({ chat: { id: lcState.chat }, continuous: true })
//       // @ts-ignore
//       .then(({ chat }) => {
//         lcState.chat = chat.id
//         chatState.updateLivechatData({ chat: chat.id })
//         lcState.active = true
//         lcState.activating = false

//         // Send any pending messages
//         // @ts-ignore
//         // lcState.pendingMessages.forEach(({ messageId, text }) => {
//         //   sendLiveChatMessage(chat.id, messageId, text)
//         // })

//         lcState.pendingMessages = []
//       })
//       // @ts-ignore
//       .catch((error) => {
//         // If the chat no longer exists, try to start a new one
//         if (
//           error.code === 'VALIDATION' ||
//           error.code === 'MISSING_CHAT_THREAD'
//         ) {
//           lcState.chat = null
//           chatState.updateLivechatData({ chat: null })
//           startChat(lcState, chatState, msgId, msgText)
//           return
//         }

//         lcState.activating = false

//         // Mark all pending messages as failed
//         lcState.pendingMessages = []
//       })
//   }, 500)
// }
